export default function Section({ id, alt, eyebrow, title, lead, children, center }) {
  return (
    <section id={id} className={`section ${alt ? 'section--alt' : ''}`}>
      <div className="container">
        {(eyebrow || title || lead) && (
          <div className={`section__head ${center ? 'center' : ''}`} style={center ? { margin: '0 auto 2.5rem' } : undefined}>
            {eyebrow && <p className="section__eyebrow">{eyebrow}</p>}
            {title && <h2 className="section__title">{title}</h2>}
            {lead && <p className="section__lead">{lead}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
